module.exports = __webpack_public_path__ + "static/media/Mechanical_Clock_Ring.ebb9f2a9.mp3";